import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'pagamento-aprovado-box',
  templateUrl: './pagamento-aprovado-box.component.html',
  styleUrls: ['./pagamento-aprovado-box.component.scss']
})
export class PagamentoAprovadoBoxComponent implements OnInit {

  @Input("carrinho") carrinho:any = null;
  public carrinhoId               = null;
  public dadosComprador           = null; 
  public hash                     = null; 
  public email                    = null;

  constructor(){ }

  /**
   * 
   * Seta o e-mail
   * 
   */
  setEmail(){

    if(this.email == null){

      if(typeof(this.carrinho.cart_dados.email) !== "undefined"){
        this.email = this.carrinho.cart_dados.email;
      }

    }

  }
  /**
   * 
   * Seta os dados do comprador
   * 
   */
  setDadosComprador(){ 

    this.dadosComprador = this.carrinho.cart_dados;   

  }
  /**
   * 
   * Set carrinho ID
   * 
   */
  setCarrinhoId(){

    if(typeof(this.carrinho.cart) !== "undefined"){
    
      this.carrinhoId = this.carrinho.cart;
    
    }else if(typeof(this.carrinho.carrinho) !== "undefined"){

      this.carrinhoId = this.carrinho.carrinho.id;

    }

  }
  /**
   * 
   * Hash
   * 
   */
  setHash(){

    if(typeof(this.carrinho.hash) != "undefined"){
      this.hash = this.carrinho.hash; 
    }

  }
  /***
   * 
   * Inicializa as Funções
   * 
   */
  ngOnInit():void{
    this.setDadosComprador();
    this.setCarrinhoId();
    this.setHash();
  }

}
